import { serialize } from 'object-to-formdata';

export default async function(params) {
  const headers = new Headers();
  const csrfToken = document.getElementsByName('csrf-token').item(0).content;
  headers.append('X-CSRF-Token', csrfToken);

  const response = await fetch(params.url, {
    method: params.method,
    headers: headers,
    body: params.method == 'GET' ? null : serialize(params.data || {}),
    credentials: "include"
  });
  return response;
};
